export const EVENT_LOG_KEY = 'v2/transit-operation-log'

export const eventLogQueryKeys = {
  all: (transitOperationId: number | null) => [EVENT_LOG_KEY, 'transit-operation', transitOperationId],
  details: (logId: number | null) => [EVENT_LOG_KEY, logId, 'details'],
}
